import { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { pwaManager } from '../PwaManager'
import styles from './UpdatePrompt.module.css'

export const UpdatePrompt = observer(() => {
    const [dismissed, setDismissed] = useState(false)

    if (!pwaManager.updateAvailable || dismissed) return null

    const handleUpdate = () => {
        pwaManager.applyUpdate()
    }

    const handleDismiss = () => {
        setDismissed(true)
    }

    return (
        <div className={styles['toast']} role="alert" aria-live="assertive">
            <span className={styles['text']}>Доступна нова версія додатку</span>
            <div className={styles['actions']}>
                <button className={styles['btnDismiss']} onClick={handleDismiss} aria-label="Відкласти оновлення">
                    Пізніше
                </button>
                <button className={styles['btnUpdate']} onClick={handleUpdate} aria-label="Оновити додаток зараз">
                    Оновити
                </button>
            </div>
        </div>
    )
})

UpdatePrompt.displayName = 'UpdatePrompt'
